export const TaskFrequencies = [
    { 'value': 'week', 'label': 'Week' },
    { 'value': 'month', 'label': 'Month' },
    { 'value': 'year', 'label': 'Year' },
];
